<template>
  <div class="w-full px-4">
    <div :class="['relative', 'w-full', { 'mb-3': !noMargin }]">
      <label
        class="block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
        v-if="label !== ''"
      >
        {{label}}
        <span v-if="required" class="text-red-500">*</span>
      </label>
      <template v-if="info!==null">
        <small class="text-gray-700 font-medium mb-2 text-left inline-block w-full" >{{ info }}</small>
      </template>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Form/FormItem.vue